// src/queryOptions.ts
function queryOptions(options) {
  return options;
}
export {
  queryOptions
};
//# sourceMappingURL=queryOptions.js.map